import { render, staticRenderFns } from "./Technologies.vue?vue&type=template&id=74ca9016&scoped=true&"
import script from "./Technologies.vue?vue&type=script&lang=js&"
export * from "./Technologies.vue?vue&type=script&lang=js&"
import style0 from "./Technologies.vue?vue&type=style&index=0&id=74ca9016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca9016",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
